import { TagRootProps } from '@chakra-ui/react';

import { Status } from '../../../constants/Utils';

export const STATUS_TO_COLOR_PALETTE_MAP: Record<
  Status,
  TagRootProps['colorPalette']
> = {
  [Status.Fail]: 'red',
  [Status.Info]: 'blue',
  [Status.Neutral]: 'brandSecondary',
  [Status.Pending]: 'purple',
  [Status.Success]: 'green',
  [Status.Warning]: 'orange',
};
